import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  open() {
    // Create modal container
    // Create modal container
    const modal = document.createElement('div')
    modal.className = 'fixed inset-0 flex items-center justify-center z-50 p-4'
    modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)' // Using inline style to ensure opacity works
    modal.setAttribute('data-video-modal-target', 'modal')

    // Create video element
    const videoContainer = document.createElement('div')
    videoContainer.className = 'relative rounded-lg overflow-hidden max-w-4xl w-full'

    const video = document.createElement('video')
    video.className = 'w-full'
    video.src = this.urlValue
    video.controls = true
    video.autoplay = true

    // Create close button
    const closeBtn = document.createElement('button')
    closeBtn.className = 'absolute top-3 right-3 text-white hover:text-gray-300'
    closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>`
    closeBtn.addEventListener('click', () => this.close())

    // Add elements to DOM
    videoContainer.appendChild(video)
    videoContainer.appendChild(closeBtn)
    modal.appendChild(videoContainer)
    document.body.appendChild(modal)

    // Add event listener to close on background click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) this.close()
    })

    // Close on escape key
    document.addEventListener('keydown', this.handleKeyDown.bind(this))
  }

  close() {
    const modal = document.querySelector('[data-video-modal-target="modal"]')
    if (modal) {
      modal.remove()
      document.removeEventListener('keydown', this.handleKeyDown)
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Escape') this.close()
  }
}
